import { toast } from '@/components/toast';
import { logger } from '@/services/logger';
import { UploadingFile } from '@/state/agent';
import { AxiosError } from 'axios';
import { MutationFunction, useMutation } from 'react-query';
import { useUpdateKnowledgeDocuments } from './useUpdateKnowledgeDocuments';

const RETRIES = 3;

export function useUpdateKnowledgeAndDocuments() {
    const { mutateAsync: updateKnowledgeDocuments } = useUpdateKnowledgeDocuments();

    const editKnowledgeAndDocumentsMut: MutationFunction<
        void,
        { knowledgeId: string; uploadingFiles: UploadingFile[]; deletedFiles: UploadingFile[] }
    > = async ({ knowledgeId, uploadingFiles, deletedFiles }) => {
        await Promise.all([updateKnowledgeDocuments({ knowledgeId, uploadingFiles, deletedFiles })]);
    };

    return useMutation('edit-agent', editKnowledgeAndDocumentsMut, {
        retry(failureCount, error: AxiosError) {
            return (
                failureCount < RETRIES &&
                !!error.response?.status &&
                ([401, 403].some(status => error.response!.status === status) || error.response.status >= 500)
            );
        },
        onError: async (error: any) => {
            logger.error('Could not update knowledge', { error });
            toast.error({ title: `Could not update knowledge`, toastId: `knowledge-update-error` });
        },
    });
}
